<script>
import i18n from '../i18n.js'
import moment from 'moment'
const pageText = window.fe.getPageText(i18n)

function getTime (dateType, time) {
  return dateType && time ? moment(time).format(dateType) : ''
}

export default {
  name: 'read-period',
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dateFormat: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      pageText
    }
  },
  computed: {
    startTime () {
      return getTime(this.dateType, this.value?.startTime)
    },
    endTime () {
      return getTime(this.dateType, this.value?.endTime)
    },
    dateType () {
      const config = {
        'yyyy-MM': 'YYYY-MM',
        'yyyy-MM-dd': 'YYYY-MM-DD',
        'yyyy-MM-dd HH:mm': 'YYYY-MM-DD HH:mm',
        'yyyy-MM-dd HH:mm:ss': 'YYYY-MM-DD HH:mm:ss'
      }
      return config[this.dateFormat]
    }
  },
  render (h) {
    const { startTime, endTime, value } = this
    return (
      <span class="period-detail">
        {(value && startTime) ? <tempalte>
          <span>{startTime}</span>
          <span>{pageText.to}</span>
          <span>{value.permanentSet ? pageText.forever : (value.endTime ? endTime : '-')}</span>
        </tempalte> : '-'}
      </span>)
  }
}
</script>